import deburr from './deburr';
import { kebabCase } from 'lodash';

export default function dataTestValue(field, sfx) {
    let suffix = typeof sfx !== 'undefined' ? '-' + kebabCase(deburr(sfx)) : '';
    if (!field) {
        return null;
    }
    let result = null;
    if (typeof field === 'string' || typeof field === 'number') {
        result = kebabCase(deburr(field));
    } else {
        result = kebabCase(deburr(field.props['data-test'] || field.props.label));
    }
    return result === '' ? null : result + suffix;
}
